// Common
import { Component, inject } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';
import { NotesWorkspaceContextService } from '@modules/notes/routing/notes-workspace-context.service';

@Component({
  selector: 'app-notes-layout',
  templateUrl: './notes-layout.component.html',
  styleUrls: ['./notes-layout.component.less', '../../styles.less'],
  standalone: false,
  providers: [NotesWorkspaceContextService],
})
export class NotesLayoutComponent {
  private readonly workspaceContext = inject(NotesWorkspaceContextService);
  public SidebarSplitViewKey = SidebarSplitViewKey;
  protected readonly app = Application.notes;
}
